import { render } from "./DefenseArmoryView.vue?vue&type=template&id=5b71693a&scoped=true"
import script from "./DefenseArmoryView.vue?vue&type=script&lang=js"
export * from "./DefenseArmoryView.vue?vue&type=script&lang=js"

import "./DefenseArmoryView.vue?vue&type=style&index=0&id=5b71693a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b71693a"]])

export default __exports__